import { WishlistWithItemsSchema } from "@apps/wishlist/schemas/WishlistWithItemsSchema";
import { object } from "superstruct";

export const DuplicateWishlistResponseSchema = object({
    wishlistsWithItems: WishlistWithItemsSchema,
});
